// extracted by mini-css-extract-plugin
export var mobileLayoutContainer = "index-module--mobileLayoutContainer--e3966";
export var mobileLayoutFullscreen = "index-module--mobileLayoutFullscreen--40593";
export var mobileLayoutLoading = "index-module--mobileLayoutLoading--664c0";